import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=bb9b5012"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=bb9b5012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports